import React from "react";
import "./index.css";
import Renderinnercontent from "./inner-content";

const Button = (props) => {
  const getClassNameUsingType = () => {
    if (props.type === "submit") {
      return "orange-button";
    } else if (props.type === "start") {
      return "orange-button";
    } else if (props.type === "ready") {
      return "orange-button";
    } else if (props.type === "resume") {
      return "dark-blue";
    } else if (props.type === "enabled report") {
      return "report-enabled";
    } else if (props.type === "disabled report") {
      return "report-disabled";
    } else if (props.type === "back") {
      return "back-button";
    }
  };

  return (
    <React.Fragment>
      {props.reportNotification && (
        <div className="report-info-modal">
          <Renderinnercontent handleModalClose={props.handleModalClose} />
        </div>
      )}

      <button
        className={"button-comp " + getClassNameUsingType()}
        style={props.style || {}}
        disabled={props.disabled}
        onMouseEnter={props.type === "ready" ? props.handleMouseEnter : null}
      >
        {props.children}
      </button>
    </React.Fragment>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/new/Utils/Button/index.jsx